import styled from 'styled-components'

// styles
import { WrapPageItem } from '../../TransactionsList/index.styles';

const WrapListAccount = styled(WrapPageItem)`
    display: flex;
    flex-direction: column;
    height: 100%;
    .row {
        grid-template-columns: 120px 1fr 125px 125px 20px 25px;
    }
    .wrap-empty {
        height: 100%;
        display: flex;
        align-items: center;
    }
`;

export {
    WrapListAccount
}